export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  publishedAt: string;
  readTime: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'art-1',
    slug: 'how-to-access-91ncon',
    title: '2026年最新91n.con访问方法完整指南',
    excerpt: '详细介绍多种访问91n.con的方法，包括直连、镜像、代理等方式，帮助您快速稳定访问目标站点。',
    content: `<p>随着网络环境的不断变化，许多用户在访问91n.con时可能会遇到各种问题。本文将为您详细介绍2026年最有效的几种访问方法，确保您能够稳定、快速地连接到91n.con。</p>
<h2>方法一：使用官方主站直连</h2>
<p>最直接的方式是通过官方主域名进行访问。如果您的网络环境支持，直接输入官方地址即可访问。建议将本站添加到浏览器书签，随时获取最新官方地址。</p>
<h2>方法二：使用镜像节点</h2>
<p>91n.con在全球部署了多个镜像节点，当主站访问不稳定时，可以选择离您地理位置最近的镜像节点。镜像节点与主站内容完全同步，使用体验一致。</p>
<p>大陆用户建议优先选择大陆优化节点，港澳台用户可使用港澳台节点，海外用户使用海外节点。</p>
<h2>方法三：DNS优化</h2>
<p>如果您能访问但速度较慢，可以尝试更换DNS服务器。推荐使用以下公共DNS：</p>
<ul><li>Cloudflare DNS: 1.1.1.1</li><li>Google DNS: 8.8.8.8</li><li>阿里DNS: 223.5.5.5</li></ul>
<h2>方法四：浏览器优化</h2>
<p>清除浏览器缓存和DNS缓存有时能解决访问问题：</p>
<ul><li>Chrome: 设置 → 隐私和安全 → 清除浏览数据</li><li>Windows: 命令行执行 ipconfig /flushdns</li><li>macOS: 终端执行 sudo dscacheutil -flushcache</li></ul>
<h2>注意事项</h2>
<p>请务必通过本页提供的官方地址访问，避免使用来源不明的第三方链接，防止信息泄露或财产损失。</p>`,
    category: 'access-guide',
    author: '91n.con 导航团队',
    publishedAt: '2026-08-01',
    readTime: '8分钟',
    tags: ['访问方法', '直连', '镜像', 'DNS', '浏览器优化'],
  },
  {
    id: 'art-2',
    slug: 'mirror-node-guide',
    title: '91n.con镜像节点选择与使用指南',
    excerpt: '了解各镜像节点的差异，根据您的地理位置和网络环境选择最优访问入口。',
    content: `<p>91n.con为了给全球用户提供更好的访问体验，部署了多个地区的镜像节点。本文将帮助您了解各节点的特点，选择最适合您的访问入口。</p>
<h2>镜像节点分布</h2>
<p>目前91n.con在全球设有以下镜像节点：</p>
<ul><li><strong>官方镜像一：</strong>亚洲通用节点，适合东南亚及日韩用户</li><li><strong>官方镜像二：</strong>亚洲优化节点，适合亚洲大部分地区用户</li><li><strong>大陆优化节点：</strong>专为中国大陆用户优化，延迟最低</li><li><strong>港澳台节点：</strong>面向港澳台地区的高速入口</li><li><strong>海外节点：</strong>面向欧美及其他海外地区用户</li></ul>
<h2>如何选择最佳节点</h2>
<p>选择节点的基本原则是"就近访问"：</p>
<ol><li>先尝试主站，主站通常提供最完整的服务</li><li>如果主站访问缓慢，选择离您最近的镜像节点</li><li>中国用户优先使用大陆优化节点</li><li>各节点功能完全一致，内容实时同步</li></ol>
<h2>节点切换最佳实践</h2>
<p>建议收藏2-3个备选节点，以便在主节点出现问题时快速切换。同时定期查看本导航页获取最新节点信息。</p>`,
    category: 'access-guide',
    author: '91n.con 导航团队',
    publishedAt: '2026-07-28',
    readTime: '6分钟',
    tags: ['镜像节点', '网络优化', '节点选择', '访问速度'],
  },
  {
    id: 'art-3',
    slug: 'new-user-registration-guide',
    title: '91n.con新用户注册与入门完全指南',
    excerpt: '从零开始，手把手教您完成91n.con的注册流程，快速上手使用各项功能。',
    content: `<p>欢迎来到91n.con！本指南将帮助新用户快速完成注册并熟悉平台的基本功能。无论您是第一次使用还是想要了解更多功能，这篇文章都能帮到您。</p>
<h2>第一步：访问官方入口</h2>
<p>首先通过本页提供的官方地址访问91n.con。请务必使用官方地址，避免注册到仿冒网站。</p>
<h2>第二步：创建账号</h2>
<p>点击页面右上角的"注册"按钮，按照提示填写以下信息：</p>
<ul><li>有效的电子邮箱地址（用于账号验证和找回密码）</li><li>设置一个安全性高的密码（建议包含大小写字母、数字和特殊字符）</li><li>同意用户协议和隐私政策</li></ul>
<h2>第三步：邮箱验证</h2>
<p>提交注册信息后，系统会向您的邮箱发送验证邮件。请在30分钟内点击邮件中的验证链接完成验证。</p>
<h2>第四步：完善个人资料</h2>
<p>验证成功后登录账户，建议完善以下信息获得更好的使用体验：</p>
<ul><li>设置个人头像</li><li>完善个人偏好设置</li><li>开启双重验证增强账号安全</li></ul>
<h2>常见注册问题</h2>
<p>如果收不到验证邮件，请检查垃圾邮件箱或尝试重新发送。如仍有问题，可通过官方渠道联系客服支持。</p>`,
    category: 'tutorials',
    author: '91n.con 导航团队',
    publishedAt: '2026-07-25',
    readTime: '7分钟',
    tags: ['注册', '新用户', '入门', '账号设置'],
  },
  {
    id: 'art-4',
    slug: 'account-security-best-practices',
    title: '91n.con账号安全防护最佳实践',
    excerpt: '了解如何保护您的91n.con账号安全，防范盗号、钓鱼等安全威胁。',
    content: `<p>账号安全是每位用户都应重视的事项。本文将详细介绍保护91n.con账号安全的最佳实践，帮助您远离各类安全威胁。</p>
<h2>一、设置强密码</h2>
<p>一个安全的密码应满足以下要求：</p>
<ul><li>长度至少12位</li><li>包含大小写字母、数字和特殊字符</li><li>不使用生日、手机号等个人信息</li><li>不同平台使用不同密码</li></ul>
<h2>二、开启双重验证（2FA）</h2>
<p>双重验证是保护账号安全的最有效手段之一。91n.con支持以下双重验证方式：</p>
<ul><li>邮箱验证码</li><li>身份验证器应用（如Google Authenticator）</li><li>短信验证码</li></ul>
<p>强烈建议所有用户开启至少一种双重验证方式。</p>
<h2>三、识别钓鱼攻击</h2>
<p>钓鱼攻击是最常见的账号威胁之一。请注意：</p>
<ul><li>91n.con不会通过邮件或短信索要您的密码</li><li>只通过本页提供的官方地址访问</li><li>注意检查网址是否正确（91n.con）</li><li>不要点击来源不明的链接</li></ul>
<h2>四、定期安全检查</h2>
<p>建议每月进行一次账号安全检查，包括查看登录记录、检查授权设备等。</p>`,
    category: 'security',
    author: '91n.con 安全团队',
    publishedAt: '2026-07-20',
    readTime: '10分钟',
    tags: ['账号安全', '密码', '双重验证', '钓鱼', '防护'],
  },
  {
    id: 'art-5',
    slug: 'mobile-access-optimization',
    title: '91n.con手机端访问优化技巧大全',
    excerpt: '在手机上流畅使用91n.con的实用技巧，包括浏览器选择、网络优化等。',
    content: `<p>越来越多用户选择在手机上访问91n.con。本文将分享一系列手机端访问优化技巧，让您在移动设备上获得最佳体验。</p>
<h2>推荐浏览器</h2>
<p>以下浏览器在访问91n.con时表现最佳：</p>
<ul><li><strong>Chrome：</strong>兼容性最好，推荐首选</li><li><strong>Safari：</strong>iOS设备最佳选择</li><li><strong>Firefox：</strong>注重隐私的用户可选</li><li><strong>Edge：</strong>Windows手机用户推荐</li></ul>
<h2>网络优化设置</h2>
<p>移动网络环境下，以下设置可提升访问速度：</p>
<ul><li>关闭其他后台应用释放带宽</li><li>使用Wi-Fi而非移动数据（更稳定）</li><li>开启浏览器的数据压缩功能</li><li>使用手机版专用节点（大陆优化节点）</li></ul>
<h2>添加到主屏幕</h2>
<p>将本导航页添加到手机主屏幕，就像使用App一样方便：</p>
<ul><li>iOS Safari: 点击分享按钮 → 添加到主屏幕</li><li>Android Chrome: 点击菜单 → 添加到主屏幕</li></ul>
<h2>省流量模式</h2>
<p>如果您使用移动数据访问，可以开启浏览器的省流量模式以减少流量消耗。</p>`,
    category: 'tutorials',
    author: '91n.con 导航团队',
    publishedAt: '2026-07-15',
    readTime: '5分钟',
    tags: ['手机', '移动端', '浏览器', '网络优化', 'iOS', 'Android'],
  },
  {
    id: 'art-6',
    slug: 'official-announcement-2026-q3',
    title: '91n.con 2026年第三季度服务升级公告',
    excerpt: '了解91n.con在2026年Q3的服务升级计划，包括新增节点、功能优化等内容。',
    content: `<p>感谢广大用户一直以来对91n.con的支持与信任。我们很高兴地宣布2026年第三季度的服务升级计划。</p>
<h2>新增节点</h2>
<p>为满足不断增长的用户需求，我们将在以下地区新增服务节点：</p>
<ul><li>东南亚节点 - 新加坡（预计8月中旬上线）</li><li>中东节点 - 迪拜（预计9月初上线）</li><li>南美节点 - 圣保罗（预计9月底上线）</li></ul>
<h2>功能优化</h2>
<p>本次升级还包括以下功能优化：</p>
<ul><li>页面加载速度提升30%</li><li>移动端体验全面升级</li><li>新增个性化内容推荐</li><li>搜索功能精准度提升</li></ul>
<h2>安全升级</h2>
<p>安全始终是我们的首要任务。本次升级将：</p>
<ul><li>全面启用新一代加密协议</li><li>升级DDoS防护能力</li><li>新增异常登录智能检测</li></ul>
<h2>用户须知</h2>
<p>升级期间可能出现短暂的服务波动，给您带来的不便敬请谅解。升级完成后，所有用户将自动享受优化后的服务。</p>`,
    category: 'announcements',
    author: '91n.con 官方团队',
    publishedAt: '2026-07-10',
    readTime: '4分钟',
    tags: ['公告', '服务升级', '新节点', '功能优化', '安全'],
  },
  {
    id: 'art-7',
    slug: 'faq-account-verification',
    title: '常见问题：账号验证失败的解决方法',
    excerpt: '遇到账号验证失败？本文汇总了最常见的验证问题及对应解决方案。',
    content: `<p>账号验证是保障账户安全的重要环节，但有时用户会遇到验证失败的情况。以下是最常见的验证问题及解决方法。</p>
<h2>问题一：收不到验证邮件</h2>
<p><strong>可能原因：</strong>邮件被误判为垃圾邮件、邮箱已满、邮件服务器延迟</p>
<p><strong>解决方案：</strong></p>
<ul><li>检查垃圾邮件箱</li><li>等待5-10分钟后刷新收件箱</li><li>将官方邮箱加入白名单</li><li>点击"重新发送验证邮件"</li></ul>
<h2>问题二：验证链接已过期</h2>
<p>验证链接有效期为30分钟。如果链接过期，只需重新登录并请求新的验证邮件即可。</p>
<h2>问题三：验证码输入错误</h2>
<p>请仔细核对验证码，注意区分大小写。如果多次输入错误，系统可能会暂时锁定，请等待15分钟后重试。</p>
<h2>问题四：手机验证失败</h2>
<p>确保手机号码填写正确，信号良好。如果使用海外号码，请确认已选择正确的国家区号。</p>`,
    category: 'faq-collection',
    author: '91n.con 客服团队',
    publishedAt: '2026-07-05',
    readTime: '5分钟',
    tags: ['验证', '邮箱', '常见问题', '账号', 'FAQ'],
  },
  {
    id: 'art-8',
    slug: 'anti-phishing-awareness',
    title: '谨防仿冒网站：91n.con反钓鱼安全警示',
    excerpt: '如何识别仿冒91n.con的钓鱼网站，保护个人信息和账号安全。',
    content: `<p>近期我们发现有部分不法分子仿冒91n.con网站，企图骗取用户账号信息。请广大用户提高警惕，认准官方入口。</p>
<h2>如何识别仿冒网站</h2>
<p>仿冒网站通常有以下特征：</p>
<ul><li>域名与官方地址略有差异（如多了字母、用数字替代字母等）</li><li>页面设计和官方不一致</li><li>索要超出正常范围的个人信息</li><li>存在明显的拼写错误</li><li>没有HTTPS安全连接</li></ul>
<h2>安全访问准则</h2>
<p>请牢记以下安全准则：</p>
<ul><li>只通过本导航页提供的官方地址访问</li><li>收藏本导航页作为唯一入口</li><li>不要点击搜索引擎中的推广广告链接</li><li>不要在非官方页面输入账号密码</li></ul>
<h2>发现仿冒网站怎么办</h2>
<p>如果您发现了疑似仿冒的网站，请通过官方渠道向我们举报。我们将及时采取法律行动保护用户权益。</p>`,
    category: 'security',
    author: '91n.con 安全团队',
    publishedAt: '2026-06-30',
    readTime: '6分钟',
    tags: ['安全', '钓鱼', '仿冒', '防骗', '警示'],
  },
  {
    id: 'art-9',
    slug: 'dns-troubleshooting',
    title: 'DNS解析问题排查与解决完整方案',
    excerpt: '当您遇到DNS相关访问问题时，本文提供从基础到高级的完整排查方案。',
    content: `<p>DNS（域名系统）问题是最常见的访问障碍之一。当您无法访问91n.con时，很可能与DNS解析有关。本文提供完整的排查与解决方案。</p>
<h2>DNS问题常见表现</h2>
<ul><li>浏览器显示"无法找到服务器"</li><li>页面长时间加载后超时</li><li>部分图片或资源无法加载</li><li>访问速度异常缓慢</li></ul>
<h2>基础排查步骤</h2>
<ol><li>尝试访问其他网站，确认是否为网络连接问题</li><li>使用其他设备（如手机）访问同一地址</li><li>切换网络（如从WiFi切换到移动数据）</li></ol>
<h2>更换DNS服务器</h2>
<p>如果确认是DNS问题，更换DNS服务器是最有效的解决方案：</p>
<ul><li>Cloudflare: 1.1.1.1 / 1.0.0.1</li><li>Google: 8.8.8.8 / 8.8.4.4</li><li>阿里: 223.5.5.5 / 223.6.6.6</li><li>114DNS: 114.114.114.114</li></ul>
<h2>清除DNS缓存</h2>
<p><strong>Windows：</strong>打开命令提示符，输入 ipconfig /flushdns</p>
<p><strong>macOS：</strong>打开终端，输入 sudo dscacheutil -flushcache; sudo killall -HUP mDNSResponder</p>
<p><strong>浏览器DNS缓存：</strong>Chrome访问 chrome://net-internals/#dns 点击"Clear host cache"</p>`,
    category: 'access-guide',
    author: '91n.con 技术团队',
    publishedAt: '2026-06-25',
    readTime: '9分钟',
    tags: ['DNS', '网络', '故障排查', '解析', '缓存'],
  },
  {
    id: 'art-10',
    slug: 'platform-features-overview',
    title: '91n.con平台核心功能全面介绍',
    excerpt: '全面了解91n.con平台的各项核心功能，发掘平台的完整使用潜力。',
    content: `<p>91n.con不仅仅是一个内容平台，更是一个功能丰富的数字生态系统。本文带您全面了解平台的各项核心功能。</p>
<h2>内容发现</h2>
<p>智能推荐系统根据您的兴趣和浏览习惯，为您推送最相关的优质内容。支持按类别、标签、热度等多种方式浏览。</p>
<h2>社区互动</h2>
<p>活跃的用户社区是91n.con的核心特色。您可以：</p>
<ul><li>参与话题讨论</li><li>关注感兴趣的创作者</li><li>收藏精彩内容</li><li>与其他用户互动交流</li></ul>
<h2>个性化设置</h2>
<p>丰富的个性化选项让您的使用体验更加舒适：</p>
<ul><li>自定义首页内容偏好</li><li>夜间模式/日间模式切换</li><li>字体大小调节</li><li>通知偏好管理</li></ul>
<h2>数据管理</h2>
<p>您的数据由您掌控。平台提供完善的数据管理工具，包括浏览历史管理、下载记录、隐私设置等。</p>`,
    category: 'tutorials',
    author: '91n.con 产品团队',
    publishedAt: '2026-06-20',
    readTime: '7分钟',
    tags: ['功能', '平台介绍', '社区', '个性化'],
  },
  {
    id: 'art-11',
    slug: 'new-nodes-announcement-2026',
    title: '重要通知：2026年新增三个全球服务节点',
    excerpt: '91n.con全球基础设施进一步扩展，新增东京、法兰克福、新加坡三大节点。',
    content: `<p>我们非常高兴地宣布，91n.con全球基础设施网络再次扩展！三个全新的服务节点已正式投入运营。</p>
<h2>新增节点详情</h2>
<ul><li><strong>东京节点：</strong>为日本和东北亚用户提供极速访问体验</li><li><strong>法兰克福节点：</strong>服务欧洲用户，延迟降低50%</li><li><strong>新加坡节点：</strong>覆盖东南亚，同时作为亚太地区重要枢纽</li></ul>
<h2>性能提升</h2>
<p>新节点上线后：</p>
<ul><li>全球平均访问延迟降低35%</li><li>欧洲用户访问速度提升50%以上</li><li>东南亚用户获得本地化高速入口</li></ul>
<h2>如何使用新节点</h2>
<p>系统会自动为您分配最优节点，您无需手动切换。如需指定节点，可在设置中选择。</p>`,
    category: 'announcements',
    author: '91n.con 官方团队',
    publishedAt: '2026-06-15',
    readTime: '3分钟',
    tags: ['公告', '新节点', '东京', '法兰克福', '新加坡'],
  },
  {
    id: 'art-12',
    slug: 'common-login-issues',
    title: '登录常见问题汇总：无法登录的10个原因和解决方法',
    excerpt: '登录遇到问题？本文列出最常见的10种登录失败原因及对应解决方案。',
    content: `<p>无法登录是最让用户困扰的问题之一。本文整理了10种常见的登录失败原因及对应的解决方案。</p>
<h2>1. 密码错误</h2>
<p>确保Caps Lock未开启，密码区分大小写。如忘记密码，使用"忘记密码"功能重置。</p>
<h2>2. 账号被锁定</h2>
<p>连续多次密码错误会导致账号临时锁定，请等待15-30分钟后重试。</p>
<h2>3. 网络连接问题</h2>
<p>检查网络连接，尝试切换网络环境或使用镜像地址。</p>
<h2>4. 浏览器缓存问题</h2>
<p>清除浏览器缓存和Cookie后重试。</p>
<h2>5. 浏览器兼容性</h2>
<p>确保使用最新版本的主流浏览器。推荐Chrome、Firefox、Safari。</p>
<h2>6. 账号未验证</h2>
<p>新注册账号需要先完成邮箱验证才能登录。</p>
<h2>7. 双重验证问题</h2>
<p>确保验证码输入正确，注意验证码有效期。</p>
<h2>8. 多地登录冲突</h2>
<p>系统检测到异常登录时可能触发安全保护。检查邮箱是否有安全通知。</p>
<h2>9. VPN/代理干扰</h2>
<p>部分VPN可能导致登录异常，尝试关闭后重试。</p>
<h2>10. 服务维护中</h2>
<p>查看本页公告区，确认是否有计划维护通知。</p>`,
    category: 'faq-collection',
    author: '91n.con 客服团队',
    publishedAt: '2026-06-10',
    readTime: '8分钟',
    tags: ['登录', '错误', '故障排除', '常见问题'],
  },
];